import { render, staticRenderFns } from "./defaultModel.vue?vue&type=template&id=0a8dff4a&scoped=true"
import script from "./defaultModel.vue?vue&type=script&lang=js"
export * from "./defaultModel.vue?vue&type=script&lang=js"
import style0 from "./defaultModel.vue?vue&type=style&index=0&id=0a8dff4a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a8dff4a",
  null
  
)

export default component.exports